module.exports = __webpack_public_path__ + "img/aseguradoras_extras.854b0f7e.jpg";